function notify (that, type, response) {
  that.$notify({ type: type, text: response, duration: 5000 })
}

export { notify }
